<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span
    v-if="localSvg"
    class="v2-icon-svg"
    :style="svgStyle"
    v-html="localSvg"
  />
  <span v-else class="material-symbols-outlined" :style="iconStyle">
    {{ iconName }}
  </span>
</template>

<script>
const svgContext = require.context(
  '!!raw-loader!../../dashboard/assets/v2/images',
  false,
  /\.svg$/
);

const localSvgIcons = svgContext.keys().reduce((acc, key) => {
  const iconKey = key.replace(/^\.\//, '').replace(/\.svg$/, '');
  const mod = svgContext(key);
  acc[iconKey] = mod && mod.default ? mod.default : mod;
  return acc;
}, {});

export default {
  name: 'V2Icon',
  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: [Number, String],
      default: 24,
    },
  },
  computed: {
    iconName() {
      return this.name || this.icon;
    },
    localSvg() {
      return localSvgIcons[this.iconName] || '';
    },
    fontSize() {
      return /^\d+(\.\d+)?$/.test(String(this.size))
        ? `${this.size}px`
        : this.size;
    },
    iconStyle() {
      const style = {
        fontSize: this.fontSize,
        fontVariationSettings: `'opsz' ${parseInt(this.size, 10) || 20}`,
      };
      if (this.color) {
        style.color = this.color;
      }
      return style;
    },
    svgStyle() {
      const style = {
        width: this.fontSize,
        height: this.fontSize,
      };
      if (this.color) {
        style.color = this.color;
      }
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.material-symbols-outlined {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  user-select: none;
  flex-shrink: 0;
}

.v2-icon-svg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  flex-shrink: 0;

  ::v-deep svg {
    width: 100%;
    height: 100%;
    display: block;
    fill: currentColor;
  }
}
</style>
